import React from 'react';
import './welcome-letter.css';
import { goBack, goToScreen } from '../../actions/router';
import { SETTINGS_SCREEN, START_OF_DAY_SCREEN } from '../../constants/routes';
import { connect } from 'react-redux';
import { WelcomeScreenModalParent } from '../../components/modal-parents/welcome-screen-modal';
import { IconButton } from '../../components/icon-button';

const WelcomeLetterScreen = props => {
    const { goBack, goToSettings, continueToStartOfDay } = props;

    return (
        <div className="welcome-screen">
            <IconButton
                iconName="back"
                type="essential"
                size="small"
                onClick={() => goBack()}
                withSpacing={true}
            />
            <main aria-label="welcome letter" className="welcome-screen__panel">
                <WelcomeScreenModalParent onClick={continueToStartOfDay} />
            </main>
            <IconButton
                iconName="settings"
                type="essential"
                size="small"
                onClick={goToSettings}
                withSpacing={true}
            />
        </div>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        goBack: () => {
            dispatch(goBack());
        },
        continueToStartOfDay: () => {
            dispatch(goToScreen(START_OF_DAY_SCREEN));
        },
        goToSettings: () => {
            dispatch(goToScreen(SETTINGS_SCREEN));
        },
    };
};

const connected = connect(null, mapDispatchToProps)(WelcomeLetterScreen);
export { connected as WelcomeLetterScreen };
